import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import 'react-toastify/dist/ReactToastify.css';
import { store } from "./store/store";
import { ToastContainer } from 'react-toastify';
import "./index.css";
import "./Static/css/latestStyles.scss";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import App from "./App";
Object.defineProperty(String.prototype, 'capitalize', {
  value: function() {
    return this.charAt(0).toUpperCase() + this.slice(1);
  },
  enumerable: false
});
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    {/* <React.StrictMode> */}
      <ToastContainer />
      <App />
    {/* </React.StrictMode> */}
  </Provider>
);
